import React from 'react';
import PropTypes from 'prop-types';
import { getStaticImageUrl } from 'client/utils/image-helpers';

export function SearchErrorScreen({ isExpired = false }) {
  return (
    <div className="expired-screen text-center px-1 py-1 my-1">
      <img
        src={getStaticImageUrl('/img/llm-search.svg')}
        alt="Error logo"
        className="error-logo mt-1_25"
        width={204}
        height={120}
      />
      {isExpired && <h2 className="heading-3">This page has expired. Please try a new search.</h2>}
      {!isExpired && <h2 className="heading-3">Please try a new search.</h2>}
    </div>
  );
}

SearchErrorScreen.propTypes = {
  isExpired: PropTypes.bool,
};
